<template>
  <div :class="wrapperWidth">
    <div
      class="form-wrapper"
      :class="{
        'has-error': error.length,
        'is-locked': input.attributes.locked || reviewMode,
      }"
    >
      <label
        :for="input.key"
        class="form-label"
        :class="{
          'cursor-pointer': !input.attributes.locked || !reviewMode,
        }"
      >
        {{ label }}
      </label>
      <div
        v-if="instructions"
        class="form-input-instruction"
        v-html="parseMarkdown(instructions)"
      />
      <div class="flex flex-wrap leading-none items-baseline">
        <div
          v-if="input.attributes.prepend || $slots.prepend"
          class="form-input-prefix"
        >
          {{ input.attributes.prepend }}
          <slot name="prepend" />
        </div>
        <slot />
        <div
          v-if="input.attributes.append || $slots.append"
          class="form-input-suffix"
        >
          {{ input.attributes.append }}
          <slot name="append" />
        </div>
        <div
          v-if="
            error.length &&
            (input.wrapper.width === 'full' || input.wrapper.width === '1/2' || input.wrapper.width === '2/3' || input.wrapper.width === '3/4' || input.wrapper.width === '1/5' || input.wrapper.width === '2/5')
          "
          class="text-negative-700 text-xs w-full mt-1"
        >
          {{ error.join(" ") }}
        </div>
        <icon
          v-if="input.attributes.locked || reviewMode"
          icon="lock"
          class="w-5 h-5 icons-grey"
        />
      </div>
      <div
        v-if="
          error.length &&
          input.wrapper.width === '1/3' &&
          input.type !== 'multiline'
        "
        class="text-negative-700 text-xs mt-2"
      >
        {{ error.join(" ") }}
      </div>
    </div>
  </div>
</template>

<script>
import { competitionStreamsMixin } from '../../mixins/competitionStreams';

export default {
  mixins: [competitionStreamsMixin],
  props: {
    error: {
      type: Array,
      default: () => [],
    },
    input: {
      type: Object,
      required: true,
    },
    reviewMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      stream: null
    }
  },
  computed: {
    label() {
      return this.getStreamOverideForKey(this?.stream, this.input.key, 'label', this.input.label)
    },
    instructions() {
      return this.getStreamOverideForKey(this?.stream, this.input.key, 'instructions', this.input.instructions)
    },
    wrapperWidth() {
      let width = "w-full ";
      switch (this.input.wrapper.width) {
        case "1/2":
          width += "md:w-1/2";
          break;
        case "1/3":
          width += "md:w-1/3";
          break;
        case "2/3":
          width += "md:w-2/3";
          break;
        case "1/4":
          width += "md:w-1/2 lg:w-1/4";
          break;
        case "3/4":
          width += "md:w-1/2 lg:w-3/4";
          break;
        case "1/5":
          width += "md:w-1/2 lg:w-1/5";
          break;
        case "2/5":
          width += "md:w-1/2 lg:w-2/5";
          break;
        case "3/5":
          width += "md:w-1/2 lg:w-3/5";
          break;
        case "4/5":
          width += "md:w-1/2 lg:w-4/5";
          break;
        case "1/6":
          width += "md:w-1/2 lg:w-1/6";
          break;
        case "5/6":
          width += "md:w-1/2 lg:w-5/6";
          break;
      }
      return width;
    },
  },
  mounted() {
      this.stream = this.$page?.project?.stream ?? null;
      document.addEventListener("apc:stream", (e) => {
        this.stream = e.detail;
      });
  },
};
</script>

<style>
.form-wrapper {
  @apply mb-8 mx-6 pt-2 pb-2 border-b-2;
  transition: border 0.15s ease-in-out;
}

.form-wrapper:focus-within {
  @apply border-primary-400;
}

.form-wrapper.has-error {
  @apply border-negative-200;
}

.form-wrapper.has-error:focus-within {
  @apply border-negative-400;
}

.form-wrapper.has-error .form-label {
  @apply text-negative-600;
}

.form-wrapper input,
.form-wrapper textarea,
.form-wrapper select {
  @apply outline-none bg-transparent;
}

.form-wrapper ::placeholder {
  @apply italic text-grey-700;
}

.form-label {
  @apply block font-semibold;
}

.form-input-prefix,
.form-input-suffix {
  @apply font-bold;
}

.form-input-prefix {
  @apply mr-2;
}

.form-input-suffix {
  @apply ml-2;
}

.form-section .form-input-instruction {
  @apply text-sm italic mb-0 mt-1;
}
</style>
